import styles from './user-entry-layout.module.css';
import { GradientTitle } from '@/components/containers/gradient-title';
import { Banner } from '@/components/banner';
import { useTranslation } from '@/contexts/i18n-context';

interface UserEntryLayoutProps {
  titleContent?: React.ReactNode;
  titleClassName?: string;
  children: React.ReactNode;
}

export function UserEntryLayout({ titleContent, titleClassName, children }: UserEntryLayoutProps) {
  return (
    <div className={styles.container}>
      {titleContent && <GradientTitle className={titleClassName}>{titleContent}</GradientTitle>}
      {children}
    </div>
  );
}

export function UserEntryLayoutBanner() {
  const { t } = useTranslation();
  return (
    <Banner type="warning" className={styles.banner} contentClassName={styles.bannerContent}>
      <p>{t('login.bannerWarning')}</p>
    </Banner>
  );
}
